init_select2 = ->
  @SEARCH_RESULTS_PARENT_SELECTOR = '.select2-results__options'
  @SEARCH_RESULTS_SELECTOR = '.select2-results__option'
  @SEARCH_FIELD_SELECTOR = '.select2-search__field'
  @KEYCODE_ENTER = 13

  $.fn.select2.defaults.set 'theme', 'bootstrap'
  $.fn.select2.defaults.set 'width', 'style'

  $('select.select2-init').select2 {
    minimumResultsForSearch: 10,
    templateResult: (d) =>
      text = if d.element and $(d.element.parentElement).data('escape-html') then escapeHtml(d.text) else d.text
      return $('<span>'+ text + '</span>')
    templateSelection: (d) =>
      text = if d.element and $(d.element.parentElement).data('escape-html') then escapeHtml(d.text) else d.text
      return $('<span>'+ text + '</span>')
  }

  # allow user to add custom options
  @createTag = (rawTag) =>
    pattern = @customOptionsSelect.data('regx') or '.*?'
    term = rawTag.term.trim()
    if term.match(new RegExp(pattern))
      id: term
      text: term
    else
      setTimeout ->
        $("#{@SEARCH_RESULTS_PARENT_SELECTOR} #{@SEARCH_RESULTS_SELECTOR}").each((id, e) ->
          if 0 == id
            $(e).css('color', 'red').text(__ 'wrong_value').show()
          else if ($(@SEARCH_RESULTS_SELECTOR).length > 2)
            $(e).remove();
        )
      , 0
      null

  @customOptionsSelect = $('select.select2-with-custom-options').select2 {
    tags: [],
    minimumResultsForSearch: 1,
    createTag: @createTag
  }

  $('select.select2-comma-init').select2 {
    tags: [],
    tokenSeparators: [',', ';']
  }

  $('select.select2-ajax-init').removeAttr('disabled').select2
    tags: on,
    tokenSeparators: [',', ';'],
    minimumInputLength: 0
    ajax:
      data: (params) ->
        q: params.term
      delay: 250
      processResults: (data) ->
        results: data.items

  $('select.select2-ajax-init-without-tags').removeAttr('disabled').select2
    tags: off,
    tokenSeparators: [',', ';'],
    minimumInputLength: 0
    ajax:
      data: (params) ->
        q: params.term
      delay: 250
      processResults: (data) ->
        results: data.items

jQuery.fn.extend {

  destroySelect2: (params = {}) ->
    return this.each((key, select) =>
      try
        select = $ select
        if select.data 'select2'
          select.select2 'destroy'
          if params.clear
            select.find('option').remove()
    )

  select2AppendValues: (values) ->
    return this.each((key, select) =>
      try
        select = $ select
        s2 = select.data 'select2'
        if !s2?
          return

        values_append = values
        if !values_append?
          return

        unless _.isArray(values_append)
          values_append = [values_append]

        unless values_append.length
          return

        values_append = _.map values_append, (value) ->
          if _.isObject(value)
            id: '' + value.id
            text: value.text
          else
            id: '' + value
            text: '' + value

        values_new = _.map s2.data(), (value) ->
          id: '' + value.id
          text: '' + value.text.trim()

        values_original = _.map select.val(), (value) -> '' + value

        for value in values_append
          unless value.id in values_original
            values_new.push value

        if values_new.length > values_original.length
          select.select2SetValues values_new
    )

  select2SetValues: (values) ->
    return this.each((key, select) =>
      try
        select = $ select
        s2 = select.data 'select2'
        if !s2?
          return

        values_set = values
        unless _.isArray(values_set)
          values_set = [values_set]

        values_new = {}
        values_new_ids = []
        for value in values_set
          if _.isObject(value)
            id = '' + value.id
            text = '' + value.text
          else
            id = '' + value
            text = '' + value
          values_new[id] = text
          values_new_ids.push id

        # if "data-tags" attribute is set, new options can be added
        if select.data('tags')
          for id, text of values_new
            if id is ''
              continue
            unless select.find("option").filter(() -> @.value is id).length
              option = $("<option>#{text}</option>").val(id)
              select.append option

        select.val(values_new_ids).trigger('change')
    )
}
